export enum ProtocolSortDirection {
  Asc = 0,
  Desc = 1,
}

export type ProtocolSortField = 'identifier' | 'name' | 'enabled' | 'needsReview' | 'createdAt' | 'updatedAt';

export interface ProtocolSearch {
  searchTerm?: string;
  diagnosis?: string;
  tag?: string;
  tags?: string[];
  code?: string;
  enabled?: boolean;
  needsReview?: boolean;
  pageSize?: number;
  continuationToken?: string | null;
  includeDeleted?: boolean;
  sortBy?: ProtocolSortField;
  sortDirection?: ProtocolSortDirection;
}

export interface ContinuationPage<T> {
  continuationToken?: string | null;
  items: T[];
}
